import { parse, stringify } from 'zipson'
import { defineStore } from 'pinia'
import type { ScheduleList, StudentScheduleList } from '~/apis/schedule/type'
import { ARRAY_POSITION } from '~/enum/enum'

export interface ScheduleState {
  selectedIdx: string | number
  selectedPosition: string | null
  selectedSchedules: StudentScheduleList[] | []
}

export const useScheduleStore = defineStore('schedule', {
  state: (): ScheduleState => ({
    selectedIdx: '',
    selectedPosition: '',
    selectedSchedules: [],
  }),
  actions: {
    init() {
      this.selectedIdx = ''
      this.selectedPosition = ''
      this.selectedSchedules = []
    },

    // 상세 페이지 상단 목록 값 설정
    setSelectedSchedules(schedules: ScheduleList[]) {
      this.selectedSchedules = schedules.map((schedule) => {
        return {
          DAILY_IDX: schedule.DAILY_IDX,
        }
      })
    },

    // 일정 이동 버튼 활성화/비활성화 처리
    setSelectedPosition(idx: number | string) {
      const movedIndex = this.selectedSchedules.findIndex(
        (schedule) => schedule.DAILY_IDX === idx,
      )
      if (movedIndex === 0) {
        this.selectedPosition = ARRAY_POSITION.FIRST
      } else if (movedIndex === this.selectedSchedules.length - 1) {
        this.selectedPosition = ARRAY_POSITION.LAST
      } else {
        this.selectedPosition = ''
      }
    },

    // 이전 스케줄 이동
    getPrevSchedule(idx: number | string) {
      const currentIndex = this.selectedSchedules.findIndex(
        (schedule) => schedule.DAILY_IDX === idx,
      )
      // 현재 인덱스가 0보다 크면 이전 스케줄의 DAILY_IDX 반환
      if (currentIndex > 0) {
        this.selectedIdx = this.selectedSchedules[currentIndex - 1].DAILY_IDX
        this.setSelectedPosition(this.selectedIdx)
        return
      }
      // 이전 스케줄이 없는 경우 현재 인덱스(첫 번째 스케줄)의 DAILY_IDX 유지
      else if (currentIndex === 0) {
        this.selectedIdx = this.selectedSchedules[currentIndex].DAILY_IDX
      }
    },

    // 다음 스케줄 이동
    getNextSchedule(idx: number | string) {
      const currentIndex = this.selectedSchedules.findIndex(
        (schedule) => schedule.DAILY_IDX === idx,
      )
      // 현재 인덱스가 유효하고, 다음 스케줄이 존재하는 경우
      if (
        currentIndex !== -1 &&
        currentIndex < this.selectedSchedules.length - 1
      ) {
        this.selectedIdx = this.selectedSchedules[currentIndex + 1].DAILY_IDX
        this.setSelectedPosition(this.selectedIdx)
        return
      }
      // 다음 스케줄이 없는 경우(마지막 스케줄) 현재 인덱스의 DAILY_IDX 유지
      else if (currentIndex === this.selectedSchedules.length - 1) {
        this.selectedIdx = this.selectedSchedules[currentIndex].DAILY_IDX
      }
    },
  },
  persist: {
    // CONFIG OPTIONS HERE
    key: 'schedule',
    storage: persistedState.localStorage,
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },
})
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useScheduleStore, import.meta.hot))
}
